import { z } from 'zod';
import { query } from '../../utils';
export const checkForFreeZaps = query({
    path: '/:subdomain/zaps/check',
    method: 'GET',
    responses: {
        200: z.object({
            hasReceivedFreeZaps: z.boolean(),
        }),
    },
    summary: 'Check if community has received free zaps and grant them if not',
});
